module.exports = __webpack_public_path__ + "img/polish.f5fc6462.png";